import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <span className="title">
        Sir ROMEL's Quiz
      </span>
      <hr className="divider" />
    </div>
  );
};

export default Header;
